import type { JobResponse } from "@/lib/api/model/jobResponse";

import type { WizardFormData, WizardStageItem } from "../store/job-store";

const DEFAULT_STAGES: WizardStageItem[] = [
  {
    id: "sourced",
    name: "Sourced",
    color: "#2B5DF3",
    description: "",
    is_system: true,
  },
  {
    id: "inbox",
    name: "Inbox",
    color: "#63D47A",
    description: "",
    is_system: false,
  },
  {
    id: "archived",
    name: "Archived",
    color: "#F84043",
    description: "",
    is_system: true,
  },
];

function mapStages(sourceStages: JobResponse["stages"]): WizardStageItem[] {
  if (!sourceStages?.length) {
    return DEFAULT_STAGES.map((stage) => ({ ...stage }));
  }

  const sorted = [...sourceStages].sort((a, b) => a.position - b.position);
  const stamp = Date.now();

  return sorted.map((stage, index) => ({
    id: stage.is_system
      ? stage.id
      : `custom-${stamp}-${index}-${stage.id.slice(0, 8)}`,
    name: stage.name,
    color: stage.color,
    description: stage.description ?? "",
    is_system: stage.is_system,
  }));
}

/**
 * Map a fully-loaded source job into the wizard form so the clone flow opens
 * pre-filled. The title is prefixed with "Copy of " (editable). Stages use
 * temporary ids for custom stages so step 2 sync creates fresh rows on the
 * cloned job. Candidates and profile imports are not copied.
 */
export function jobToWizardPrefill(source: JobResponse): WizardFormData {
  return {
    sourcingType: "scratch",
    title: `Copy of ${source.title}`.slice(0, 255),
    description: source.description ?? "",
    managerId: source.job_manager_id ?? null,
    employerId: source.employer_id,
    stages: mapStages(source.stages),
    uploadedFiles: [],
    importUrls: [],
    importStageId: null,
    // Clones are always scratch — ATS import fields stay empty.
    connectionId: null,
    remoteJobId: null,
  };
}
